<div class="disclaimer-info-container dynamic-text">
  <h2 class="disclaimer-title">{{ title | translate }}</h2>
  <p class="disclaimer-desc">{{ description | translate }}</p>
</div>
